/*
  Cart terms agreement (The Stepwise Shelf).
  Any element marked [data-sws-terms-scope] containing an [data-sws-terms]
  checkbox: checkout buttons inside it can't be used until the box is ticked,
  and express checkout buttons stay hidden (see stepwise.css). Uses event
  delegation so it survives the cart drawer re-rendering its HTML.
*/
(function () {
  function scopeOf(el) { return el.closest('[data-sws-terms-scope]'); }

  function sync(scope) {
    if (!scope) return;
    var box = scope.querySelector('[data-sws-terms]');
    if (!box) return;
    scope.querySelectorAll('[name="checkout"], .sws-summary__checkout, .cart__checkout-button').forEach(function (btn) {
      btn.setAttribute('aria-disabled', box.checked ? 'false' : 'true');
    });
    var msg = scope.querySelector('[data-sws-terms-msg]');
    if (msg && box.checked) msg.hidden = true;
  }

  function syncAll() { document.querySelectorAll('[data-sws-terms-scope]').forEach(sync); }

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-sws-terms]')) sync(scopeOf(e.target));
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"]');
    if (!btn) return;
    var scope = scopeOf(btn);
    if (!scope) return;
    var box = scope.querySelector('[data-sws-terms]');
    if (box && !box.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var msg = scope.querySelector('[data-sws-terms-msg]');
      if (msg) msg.hidden = false;
      box.focus();
    }
  }, true);

  // Re-apply after the cart drawer or cart page updates its HTML.
  new MutationObserver(syncAll).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', syncAll);
  syncAll();
})();
